import "./baseConfig/font.css.ts.vanilla.mjs";
import "./draggedUpload.css.ts.vanilla.mjs";
var _ = "p273__draggedUpload-45d7_fc09e1570__1o82jj31", e = "p273__draggedUpload-45d7_fc09e1570__1o82jj30";
export {
  _ as draggedUploadListStyle,
  e as draggedUploadStyle
};
//# sourceMappingURL=draggedUpload.mjs.map
